/**
 * Created by B032151 on 11/22/2016.
 */
import createReactClass from "create-react-class";

import React from "react";
import { RunCompare } from "./runCompare";
import { ControlLabel } from "react-bootstrap";
import { SubdivisionActions } from "../actions/subdivisionActions";

function getStateFromStores() {
  return {};
}

var CompareGisEnvView = createReactClass({
  componentDidMount: function () {},

  componentWillUnmount: function () {},

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },
  selectCompareGisEnv: function (event) {
    var val = event.target.value;
    console.log("Schematic changed the value is " + val);
    window.compareGisEnvironment = val;
    var selectedSub = $("#subdivisionSelect").val();
    if (selectedSub != 0 && selectedSub != null) {
      SubdivisionActions.selectChanged(selectedSub);
      /* dispatcher.dispatch({
                 type: ActionTypes.COMPARE_GIS_ENVIRONMENT_CHANGED,
                 selectedschematic: val,
                 selectedSub: selectedSub
             });*/
    }
  },

  render: function () {
    var environments = [];

    environments.push(
      <option key="dev" value="dev">
        DEV
      </option>
    );
    environments.push(
      <option key="trial" value="trial" selected="selected">
        TRIAL
      </option>
    );
    environments.push(
      <option key="prod" value="prod">
        PROD
      </option>
    );

    var environmentList = (
      <div style={{ display: "inline", color: "black" }}>
        <ControlLabel style={{ color: "gray" }}>Right Schematic:</ControlLabel>{" "}
        <select id="gisSelect" onChange={this.selectCompareGisEnv}>
          {environments}
        </select>
      </div>
    );

    return (
      <div style={{ display: "inline", color: "black" }}>
        {environmentList} <RunCompare />
      </div>
    );
  },
});

export default CompareGisEnvView;
